import { Member } from "../../types/Member.types";

import { createNonPaidMember, createPaidMember } from "./builders/createMember";

export const testDriveMember: Member = createNonPaidMember();

// Legacy HDC
export const legacyUsAaaMember: Member = createPaidMember({
  assets: [
    {
      product: { code: "USMEMB0", isVIP: false, level: 2, benefits: [] },
    },
  ],
});
export const legacyUsSecondGearMember: Member = createPaidMember({
  assets: [
    {
      product: { code: "USMEMB2", isVIP: false, level: 2 },
    },
  ],
});
export const legacyCanadaSecondGearMember: Member = createPaidMember({
  assets: [
    {
      product: { code: "CANMEMB2", isVIP: false, level: 2 },
    },
  ],
});
export const legacyUsVipMember: Member = createPaidMember({
  assets: [
    {
      product: { code: "USMEMBVIP", isVIP: true, level: 2 },
    },
  ],
});
export const legacyCanadaVipMember: Member = createPaidMember({
  assets: [
    {
      product: { code: "CANMEMBVIP", isVIP: true, level: 2 },
    },
  ],
});

// Omni HDC
export const omniUsSecondGearMember: Member = createPaidMember({
  assets: [
    {
      omniOrderId: "1234",
      product: { code: "USMEMBHDC2", isVIP: false, level: 2 },
    },
  ],
});
export const omniCanadaSecondGearMember: Member = createPaidMember({
  assets: [
    {
      omniOrderId: "1234",
      product: { code: "CANMEMBHDC2", isVIP: false, level: 2 },
    },
  ],
});
export const omniUsVipMember: Member = createPaidMember({
  assets: [
    {
      omniOrderId: "1234",
      product: { code: "USMEMBHDCVIP", isVIP: true, level: 2 },
    },
  ],
});
export const omniCanadaVipMember: Member = createPaidMember({
  assets: [
    {
      omniOrderId: "1234",
      product: { code: "CANMEMBHDCVIP", isVIP: true, level: 2 },
    },
  ],
});
